import angular from 'angular';

(function() {
    'use strict';
    var core = angular.module('app.kissinvoice');

    core.constant(
        'KISS_INVOICE',
        Object.freeze({
            transModes: ['all', 'email', 'upload', 'webinput'],
            functionalStatuses: [
                'all',
                'sending_to_epdf',
                'processing_in_epdf',
                'to_check',
                'deleted',
                'rejected',
                'rejection_managed',
                'waiting_proof_diary',
                'sending_to_zedoc',
                'sent_to_zedoc',
                'draft',
                'sending_to_demat',
                'sent_to_demat',
                'checked'
            ],
            pagination: {
                defaultPageSize: 20,
                defaultSort: [
                    {
                        direction: 'DESC',
                        property: 'updateDate'
                    }
                ],
                defaultPage: 0
            },
            columnFieldMap: [
                {
                    field: 'seller.getNameForList()',
                    property: 'sellerName'
                },
                {
                    field: 'buyer.getNameForList()',
                    property: 'buyerName'
                },
                {
                    field: 'getTransMode()',
                    property: 'transMode'
                },
                {
                    field: 'creationDate',
                    property: 'creationDate'
                },
                {
                    field: 'updateDate',
                    property: 'updateDate'
                },
                {
                    field: 'getStatus()',
                    property: 'status'
                },
                {
                    field: 'refDoc',
                    property: 'refDoc'
                },
                {
                    field: 'refKiss',
                    property: 'refKiss'
                },
                {
                    field: 'techId',
                    property: 'techId'
                }
            ]
        })
    );
})();
